<div class="mt-channel-event">
  <div class="mt-channel-event-text">
    {{getChannelEventText()}}
  </div>
</div>
